module.exports = __webpack_public_path__ + "static/media/april_yeh.27939642.jpg";